import {Component, ElementRef, OnDestroy, OnInit} from '@angular/core';
import {
  AbstractControl,
  FormBuilder,
  FormControl,
  FormGroup,
  ValidationErrors,
  ValidatorFn,
  Validators
} from '@angular/forms';
import {TemporaryScoreService} from '../../services/temporary-score.service';
import {Location} from '@angular/common';
import {Router} from "@angular/router";
import {Observable} from 'rxjs';
import {Config} from '../../domain/config';
import {ConfigService} from '../../services/config.service';

// Custom validator function
export function alphanumericValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const valid = /^[a-zA-Z0-9]*$/.test(control.value);
    return valid ? null : {alphanumeric: true};
  };
}

@Component({
  selector: 'tech-core-quiz-sign-up',
  standalone: false,
  templateUrl: './sign-up.component.html',
  styleUrl: './sign-up.component.scss'
})
export class SignUpComponent implements OnInit, OnDestroy {

  public config$: Observable<Config> | undefined
  public signupData: FormGroup
  public userInput: FormControl<string | null>;
  private resizeListener: (() => void) | null = null;

  constructor(
    private location: Location,
    public fb: FormBuilder,
    private configService: ConfigService,
    public temporaryScoreService: TemporaryScoreService,
    public router: Router,
    private el: ElementRef
  ) {

    this.userInput = new FormControl('', [Validators.required, alphanumericValidator(), Validators.maxLength(12)]);

    this.signupData = this.fb.group({
      userInput: this.userInput,
    })

  }

  ngOnInit() {
    this.config$ = this.configService.getConfig()

    this.resizeListener = () => {
      const isKeyboardOpen = window.innerHeight < screen.height * 0.75;
      const bottomImageElement = this.el.nativeElement.querySelector('.bottom-image');
      const topImageElement = this.el.nativeElement.querySelector('top-image');
      if (bottomImageElement) {
        bottomImageElement.style.display = isKeyboardOpen ? 'none' : 'block';
      }
      if (topImageElement) {
        topImageElement.style.display = isKeyboardOpen ? 'none' : 'block';
      }
    };
    window.addEventListener('resize', this.resizeListener);
  }

  ngOnDestroy() {
    if (this.resizeListener) {
      window.removeEventListener('resize', this.resizeListener);
    }
  }

  confirm() {
    if (this.userInput.valid) {
      let userName = this.userInput.value!;

      this.temporaryScoreService.createTemporaryScore(userName).subscribe({
        next: (response) => {
          this.router.navigate(["/instructions"], {queryParams: {username: userName}});
        },
        error: (err) => {
          if (err.status === 409) {
            this.userInput.setErrors({usernameTaken: true});
          } else {
            console.error(err);
          }
        }
      });
    }
  }

  isEnabled() {
    return !this.userInput.valid;
  }

  navigateBack() {
    this.location.back();
  }

  hasError() {
    if (!this.userInput.touched && !this.userInput.dirty) {
      return false;
    }

    return this.userInput.hasError('required') ||
      this.userInput.hasError('alphanumeric') ||
      this.userInput.hasError('usernameTaken') ||
      this.userInput.hasError('maxlength');
  }

  changeError() {
    if (this.userInput.hasError('required')) {
      return "Username is required";
    }

    if (this.userInput.hasError('alphanumeric')) {
      return "Username can only contain letters and numbers";
    }

    if (this.userInput.hasError('usernameTaken')) {
      return "Username is already taken";
    }

    if (this.userInput.hasError('maxlength')) {
      return "Username can only be 12 letter long";
    }

    return "Error";
  }

}
